import React from 'react';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import HowItWorks from '../components/HowItWorks';
import DownloadCTA from '../components/DownloadCTA';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Header />
      <HeroSection />
      <FeaturesSection />
      <HowItWorks />
      <DownloadCTA />
      <Footer />
    </div>
  );
};

export default Home;
